import { ChoicesOrderUnitMeasure } from '../../orders/types';

export const getAmountDecorator = (unitMeasure: string) => {
  switch (unitMeasure) {
    case ChoicesOrderUnitMeasure.amount:
      return {
        prefix: '$',
        suffix: '',
        decimalScale: 2,
      };
    case ChoicesOrderUnitMeasure.quantity:
      return {
        prefix: '',
        suffix: '',
        decimalScale: 0,
      };
    case ChoicesOrderUnitMeasure.percentageAmount:
      return {
        prefix: '',
        suffix: '%',
        decimalScale: 2,
      };
    default:
      return {
        prefix: '$',
        suffix: '',
        decimalScale: 2,
      };
  }
};
